import type { TreasuryPlan, TreasuryPosition } from "./treasury";
export type CaravanTier = 0 | 1 | 2;
export type CaravanState = "preview" | "ready" | "travelling" | "arriving" | "completed";
/** Visual ranks only; prices, terms and plan IDs remain server-owned. */
export function caravanTier(plan: TreasuryPlan, catalog: readonly TreasuryPlan[]): CaravanTier {
  const values = [...new Set([...catalog, plan].map(p => p.nominalMicros))]
    .sort((a, b) => BigInt(a) < BigInt(b) ? -1 : BigInt(a) > BigInt(b) ? 1 : 0);
  return Math.min(2, Math.max(0, values.indexOf(plan.nominalMicros))) as CaravanTier;
}
export function caravanState(position?: TreasuryPosition, now = 0): CaravanState {
  if (!position || position.status === "confirming") return "ready";
  if (position.status === "completed" && position.principalPaidAt) return "completed";
  return position.status === "settling" || now >= Date.parse(position.maturesAt) ? "arriving" : "travelling";
}
export function caravanMotion(ms: number, moving: boolean, reduced: boolean) {
  const t = Math.max(0, ms) / 1000;
  return !moving || reduced ? { wheel: 0, bob: 0, travel: 0 } :
    { wheel: t * 1.8, bob: Math.sin(t * 5) * .65 + Math.sin(t * 9) * .25, travel: t * 32 };
}
